import React, { ReactNode } from 'react';
import { SettingsSectionStyle } from './styles';

type SettingsSectionProps = { title: string; description?: string; action?: ReactNode; children: ReactNode };

export const SettingsSection = (props: SettingsSectionProps): React.JSX.Element => {
  const { title, description, action, children } = props;
  return (
    <SettingsSectionStyle>
      <header>
        <div>
          <h3>{title}</h3>
          {description && <p>{description}</p>}
        </div>
        {action}
      </header>
      {children}
    </SettingsSectionStyle>
  );
};
